// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";

function initial(account_id, label) {
  return {
    account_id,
    label,
    items: /* [] */ 0,
    cursor: undefined,
    loading: true,
    pending: false,
    message: ""
  };
}

function $$boolean(json, key) {
  const value = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(json, key));
  if (value !== undefined) {
    return value;
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_workspace_sharing"
    });
}

function decode(json) {
  return {
    id: Mapre_wire__Json.string(json, "id"),
    name: Mapre_wire__Json.string(json, "name"),
    shared: $$boolean(json, "shared"),
    current: $$boolean(json, "current")
  };
}

function update(t, message) {
  if (/* tag */ typeof message !== "object" && typeof message !== "function") {
    if (message === /* Pending */ 3) {
      return {
        account_id: t.account_id,
        label: t.label,
        items: t.items,
        cursor: t.cursor,
        loading: t.loading,
        pending: true,
        message: ""
      };
    } else {
      return t;
    }
  }
  switch (message.TAG) {
    case /* Loading */ 2 :
      return {
        account_id: t.account_id,
        label: t.label,
        items: message._2 ? t.items : /* [] */ 0,
        cursor: t.cursor,
        loading: true,
        pending: t.pending,
        message: ""
      };
    case /* Loaded */ 3 :
      const items = message._0;
      return {
        account_id: t.account_id,
        label: t.label,
        items: message._2 ? Stdlib.$at(t.items, items) : items,
        cursor: message._1,
        loading: false,
        pending: false,
        message: t.message
      };
    case /* Saved */ 4 :
      const shared = message._1;
      const id = message._0;
      return {
        account_id: t.account_id,
        label: t.label,
        items: Stdlib__List.map((function (w) {
          if (w.id === id) {
            return {
              id: w.id,
              name: w.name,
              shared,
              current: shared
            };
          } else {
            return w;
          }
        }), t.items),
        cursor: t.cursor,
        loading: t.loading,
        pending: false,
        message: "Sharing updated."
      };
    case /* Failed */ 5 :
      return {
        account_id: t.account_id,
        label: t.label,
        items: t.items,
        cursor: t.cursor,
        loading: false,
        pending: false,
        message: message._0
      };
    default:
      return t;
  }
}

function busy(t) {
  if (t.loading) {
    return true;
  } else {
    return t.pending;
  }
}

export {
  initial,
  decode,
  update,
  busy,
}
/* Mapre_wire__Json Not a pure module */
